/* eslint-disable @typescript-eslint/no-explicit-any */
import { openDB } from 'idb';

const DB_NAME = 'pabandi-portal-cache';
const STORE_NAME = 'api-cache';

export const getDB = () =>
  openDB(DB_NAME, 1, {
    upgrade(db:any) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });

export const getCachedResponse = async (key: string) => {
  try {
    const db = await getDB();
    return await db.get(STORE_NAME, key);
  } catch (err) {
    console.warn('[idbCache] get failed', err);
    return undefined;
  }
};

export const setCachedResponse = async (key: string, data: any) => {
  try {
    const db = await getDB();
    await db.put(STORE_NAME, data, key);
  } catch (err) {
    console.warn('[idbCache] set failed', err);
  }
};

export const deleteCachedResponse = async (key: string) => {
  try {
    const db = await getDB();
    await db.delete(STORE_NAME, key);
  } catch (err) {
    console.warn('[idbCache] delete failed', err);
  }
};

export const clearCache = async () => {
  try {
    const db = await getDB();
    await db.clear(STORE_NAME);
  } catch (err) {
    console.warn('[idbCache] clear failed', err);
  }
};

export const getAllCacheKeys = async (): Promise<string[]> => {
  try {
    const db = await getDB();
    const keys = await db.getAllKeys(STORE_NAME);
    return keys as string[];
  } catch (err) {
    console.warn('[idbCache] getAllCacheKeys failed', err);
    return [];
  }
};

// Deletes every entry whose path portion (substring before '?') starts with `prefix`.
// Prefix is normalized by stripping a single leading '/'.
export const deleteCacheByPrefix = async (prefix: string): Promise<void> => {
  try {
    const normalized = prefix.replace(/^\//, '');
    const keys = await getAllCacheKeys();
    const toDelete = keys.filter((k) => {
      const path = k.split('?')[0].replace(/^\//, '');
      return path === normalized || path.startsWith(normalized + '/');
    });
    if (toDelete.length === 0) return;
    const db = await getDB();
    await Promise.all(toDelete.map((k) => db.delete(STORE_NAME, k)));
  } catch (err) {
    console.warn('[idbCache] deleteCacheByPrefix failed', err);
  }
};
